export default {
    environment: 'beta',
    frontendhost: 'https://beta.clipthecard.com',
    backendhost: 'https://beta.clipthecard.com',
    oidcurl: 'https://clipthecard.com/auth'
};
//# sourceMappingURL=config-beta.js.map